import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { replaceTokensInString } from '../../../utils';
const ProductListItemsCount = ({
  currentItemsCount,
  totalItemsCount,
  isMD = true
}) => {
  const [t] = useTranslation();
  const styleClasses = isMD ? 'text-start m-0' : 'text-center m-3';

  return currentItemsCount > 0 ? (
    <p
      className={`${styleClasses} text-md color-extra-dark-gray text-break`}
      data-testid="item-count"
    >
      {replaceTokensInString(t('SHOWING'), currentItemsCount, totalItemsCount)}
    </p>
  ) : null;
};

ProductListItemsCount.propTypes = {
  currentItemsCount: PropTypes.number,
  totalItemsCount: PropTypes.number,
  isMD: PropTypes.bool
};
export default ProductListItemsCount;
